// extracted by mini-css-extract-plugin
export var statItem = "_by-1";
export var statsRow = "_by-0";